module.exports = __webpack_public_path__ + "static/media/Adobe_Illustrator_CC_icon 14.ccf8b575.png";